import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatMenuModule } from '@angular/material/menu';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatSortModule } from '@angular/material/sort';
import { MatTableModule } from '@angular/material/table';
import { MatInputModule } from '@angular/material/input';
import { MatTreeModule } from '@angular/material/tree';
import { MatCardModule } from '@angular/material/card';
import { MatSelectModule } from '@angular/material/select';
import { MatNativeDateModule } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatDialogModule } from '@angular/material/dialog';
import { NgxMaterialTimepickerModule } from 'ngx-material-timepicker';
import { MatExpansionModule } from '@angular/material/expansion';
import { NgxMatDatetimePickerModule, NgxMatNativeDateModule } from '@angular-material-components/datetime-picker';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { DialogModule } from 'primeng/dialog';
import { TreeModule } from 'primeng/tree';
import { DropdownModule } from 'primeng/dropdown';
import { NgxSpinnerModule } from 'ngx-spinner';
import { MaterialModule } from 'src/app/material-module';
import { ChartsModule } from 'ng2-charts';
import { NgApexchartsModule } from 'ng-apexcharts';
import { DashboardRoutingModule } from './dashboard-routing.module';
import { HomeModule } from '../home.module';
import { MaintenanceBoardComponent } from './maintenance-board/maintenance-board.component';
import { OeeDashboardComponent } from './oee-dashboard/oee-dashboard.component';
import { AgGridModule } from 'ag-grid-angular';
import { MatSelectFilterModule } from 'mat-select-filter';
import { ChartModule } from 'angular-highcharts';
import { ProductionQualityDashboardComponent } from './production-quality-dashboard/production-quality-dashboard.component';
import { QuotidianDashboardComponent } from './quotidian-dashboard/quotidian-dashboard.component';
import { MatTooltipModule } from '@angular/material/tooltip';
import { DtParetoDashboardComponent } from './dt-pareto-dashboard/dt-pareto-dashboard.component';
import { TranslateModule } from '@ngx-translate/core';
import { GenealogyDashboardComponent } from './genealogy-dashboard/genealogy-dashboard.component';
import { GenealogyDashboardComponentVersion2 } from './genealogy-dashboard-version2/genealogy-dashboard-version2.component';
import { AdminDashboardComponent } from './admin-dashboard/admin-dashboard.component';
import { EnergyDashboardComponent } from './energy-dashboard/energy-dashboard.component';
import { HighchartsChartModule } from 'highcharts-angular';
import { ParameterAnalysisDashboardComponent } from './parameter-analysis-dashboard/parameter-analysis-dashboard.component';
import { LiveDashboardComponent } from './live-dashboard/live-dashboard.component';
import { NgxMatSelectModule } from 'src/app/ngx-mat-select/ngx-mat-select.module';
import { ToggleButtonComponent } from 'src/app/services/toggle-button.component';
import { ArrayFilterParameterPipe } from 'src/app/array.pipes.parameter';

@NgModule({
  imports: [
    CommonModule,
    TranslateModule.forChild({
      extend: true,
    }),
    ChartsModule,
    HomeModule,
    NgApexchartsModule,
    DashboardRoutingModule,
    MaterialModule,
    MatMenuModule,
    MatButtonModule,
    MatCheckboxModule,
    MatTableModule,
    MatPaginatorModule,
    MatSortModule,
    MatFormFieldModule,
    MatInputModule,
    MatTreeModule,
    MatCardModule,
    MatSelectModule,
    MatNativeDateModule,
    MatDatepickerModule,
    MatDialogModule,
    MatTooltipModule,
    NgxMaterialTimepickerModule,
    MatExpansionModule,
    NgxMatDatetimePickerModule,
    NgxMatNativeDateModule,
    FormsModule,
    ReactiveFormsModule,
    DialogModule,
    TreeModule,
    DropdownModule,
    NgxSpinnerModule,
    AgGridModule,
    MatSelectFilterModule,
    ChartModule,
    HighchartsChartModule,
    NgxMatSelectModule.forRoot({ maxWidthForMobileView: 600, inFirstLoadCallSearcher: true, inFirstLoadSearcherValue: '', emptyLabel: 'no entry found', noMoreResultLabel: 'no more found', useInfiniteScroll: false, searchBoxPlaceholder: 'Search', maximumResultForShow: 4000, useMobileView: false, valueMember: 'key', displayMember: 'value', mobileViewType: 'FullScreen', }),
  ],
  declarations: [
    MaintenanceBoardComponent,
    OeeDashboardComponent,
    ProductionQualityDashboardComponent,
    QuotidianDashboardComponent,
    DtParetoDashboardComponent,
    GenealogyDashboardComponent,
    GenealogyDashboardComponentVersion2,
    AdminDashboardComponent,
    EnergyDashboardComponent,
    ParameterAnalysisDashboardComponent,
    LiveDashboardComponent,
    ToggleButtonComponent,
    ArrayFilterParameterPipe,
    
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class DashboardModule { }
